export const fbPayloadValuesToNames = {
  75: [
    "ald automotive limited",
    "ald automotive ltd",
    "ALD Automotive UK",
    "aldermore bank asset finance",
    "Aldermore Bank PLC",
    "AUDI FINANCE",
    "Audi Financial Services",
    "Bentley Financial Services",
    "Dacia Financial Services",
    "FERRARI FINANCIAL SERVICES",
    "FERRARI FINANCIAL SERVICES (I)",
    "ge capital motor finance limited",
    "Honda Finance",
    "honda finance europe plc",
    "honda finance europe plc (i)",
    "Hyundai Capital",
    "hyundai capital uk ltd",
    "hyundai capital uk ltd (i)",
    "Kia Finance",
    "Lombard Asset Finance Group",
    "lombard asset finance group (i)",
    "lombard business finance",
    "Nissan Financial Services",
    "PORCHE FINANCIAL SERVICES GB LTD",
    "Porsche Financial Services",
    "RCI Financial Services",
    "rci financial services limited",
    "rci financial services ltd",
    "rci financial services ltd (personal)(i)",
    "Renault Financial Services",
    "SEAT FINANCE",
    "SEAT Financial Services",
    "Skoda Finance",
    "VOLKSWAGEN COMMERCIAL FINANCE",
    "volkswagen finance",
    "volkswagen financial services no.2 ltd",
    "volkswagen financial svcs ltd - cons (i)",
    "VOLKSWAGEN FINANCIAL SVCS LTD-CONS",
    "Volkwagen Financial Services",
  ],
  100: [
    "fce bank plc",
    "FCE Bank Plc T/A Ford Credit",
    "ford credit",
    "FORD CREDIT EUROPE PLC",
  ],
  150: [
    "Alphera Financial Services",
    "alphera financial services (i)",
    "Autobank Financial Services",
    "bmw finance",
    "BMW Financial Services",
    "BMW Financial Services (GB) Limited",
    "bmw financial services (gb) ltd",
    "bmw financial svcs t/a alphera",
    "Citreon Finance",
    "Clydesdale Finance/Barclays Partner Finance",
    "clydesdale financial services ltd",
    "GMAC",
    "gmac uk plc",
    "MERCEDES BENZ FNANCIAL SVS UK LTD",
    "mercedes benz fnancial svs uk ltd (i)",
    "Mercedes-Benz Financial Services",
    "mercedes-benz financial services uk limited",
    "mercedes-benz financial services uk ltd",
    "Mini Financial Services",
    "Peugeot Financial Services",
    "PSA Finance",
    "PSA FINANCE UK",
    "Stellantis Financial Services",
    "stellantis financial services (i)",
    "stellantis financial services uk",
    "stellantis financial services uk limited",
    "stellantis financial services uk ltd",
    "stellantis financial services uk ltd (i)",
  ],
  200: [
    "ca auto finance uk ltd",
    "CLOSE BROTHERS LIMITED",
    "close brothers ltd",
    "Close Brothers Motor Finance",
    "CLOSE MOTOR FINANCE LIMITED",
    "close motor finance limited (i)",
    "fca automotive services uk limited (i)",
    "fca automotive services uk ltd",
    "FCA Automotive Services/CA Auto Finance",
    "FGA CAPITAL UK LIMITED CONSUMER",
    "Hitachi Capital",
    "HITACHI CAPITAL CONSUMER FINANCE",
    "Mitsubishi Capital",
    "mitsubishi hc capital uk plc novuna (i)",
    "Novuna",
    "novuna business finance",
    "NOVUNA CONSUMER FINANCE",
    "novuna vehicle solutions",
    "novuna vehicle solutions limited",
  ],
  250: [
    "Bank of Scotland",
    "Bank of Scotland Motor",
    "BANK OF SCOTLAND PLC",
    "bank of scotland plc (i)",
    "Black Horse",
    "BLACK HORSE DEALER FINANCE-CONS",
    "black horse limited",
    "Black Horse Limited (No. 2)",
    "black horse ltd",
    "black horse ltd (i)",
    "Halifax",
    "halifax (i)",
    "halifax motor",
    "Halifax Motors",
    "international motor finance limited",
    "International Motors Finance Limited",
    "jaguar",
    "Jaguar Financial Services",
    "jaguar uwrite by black horse",
    "Jeep Financial Services",
    "land rover",
    "Land Rover Financial Services",
    "land rover uwrite by black horse",
    "Lloyds Bank",
    "lloyds bank motor",
    "LLOYDS BANK PLC",
    "lloyds bank plc (i)",
    "MotoNovo Finance",
    "motonovo finance(2) (i)",
    "MOTONOVO FINANCE2",
    "PROTON FINANCE LTD",
    "SANTANDER CONSUMER",
    "santander consumer (i)",
    "santander consumer (uk) plc",
    "Santander Consumer Finance",
    "santander consumer finance (uk) plc",
    "SANTANDER CONSUMER UK PLC",
    "Shogun Finance",
    "shogun finance ltd",
    "Suzuki Financial Services",
  ],
  0: [
    "247 money",
    "247Money",
    "ARKLE FINANCE LTD",
    "ARKLE FINANCE LTD T/A EVINGTON",
    "Burnley Savings And Loans Ltd",
    "burnley savings and loans ltd (i)",
    "CAR FINANCE 247",
    "car finance 247 (i)",
    "car finance247 limited",
    "clydesdale finance",
    "clydesdale finance (i)",
    "Conister Bank Limited",
    "conister bank limited (i)",
    "CONISTER BANK LTD",
    "conister bank ltd (i)",
    "Credo Asset Finance Ltd",
    "Credo Capital Finance",
    "credo capital finance ltd",
    "CREDO CAPITAL FINANCE LTD (I)",
    "Hartwell Finance",
    "hartwell finance (i)",
    "hartwell finance limited",
    "hartwell finance ltd",
    "Hippo Motor Finance",
    "HYUNDAI CAR FINANCE LTD",
    "Ignition Credit Plc",
    "Lexus Financial Services",
    "Mallard Vehicle Finance",
    "mallard vehicle finance (i)",
    "Mazda Financial Services",
    "METRO BANK PLC (I)",
    "MG Motor Financial Services",
    "RATESETTER",
    "ratesetter (i)",
    "RateSetter (Metro Bank PLC)",
    "ratesetter com",
    "retail money market ltd (ratesetter.com)",
    "Toyota Financial Services",
    "toyota financial services (uk) plc",
    "toyota financial services (uk) plc (i)",
    "TOYOTA FINANCIAL SERVICES UK PLC",
    "UNITED TRUST",
    "United Trust Bank",
    "UNITED TRUST BANK LIMITED",
    "united trust bank ltd",
    "V12 VEHICLE FINANCE PCP",
    "Vauxhall Finance",
    "VAUXHALL FINANCE UK",
    "volvo",
    "VOLVO CAR FINANCIAL SERVICES UK LTD",
    "volvo car financial services uk ltd (i)",
    "VOLVO CARS UK",
    "volvo finance",
    "Volvo Financial Services",
  ],
};

export const fbPayloadNamesToValues = {
  "ald automotive limited": 75,
  "ald automotive ltd": 75,
  "ald automotive uk": 75,
  "aldermore bank asset finance": 75,
  "aldermore bank plc": 75,
  "audi finance": 75,
  "audi financial services": 75,
  "bentley financial services": 75,
  "dacia financial services": 75,
  "ferrari financial services": 75,
  "ferrari financial services (i)": 75,
  "ge capital motor finance limited": 75,
  "honda finance": 75,
  "honda finance europe plc": 75,
  "honda finance europe plc (i)": 75,
  "hyundai capital": 75,
  "hyundai capital uk ltd": 75,
  "hyundai capital uk ltd (i)": 75,
  "kia finance": 75,
  "lombard asset finance group": 75,
  "lombard asset finance group (i)": 75,
  "lombard business finance": 75,
  "nissan financial services": 75,
  "porche financial services gb ltd": 75,
  "porsche financial services": 75,
  "rci financial services": 75,
  "rci financial services limited": 75,
  "rci financial services ltd": 75,
  "rci financial services ltd (personal)(i)": 75,
  "renault financial services": 75,
  "seat finance": 75,
  "seat financial services": 75,
  "skoda finance": 75,
  "volkswagen commercial finance": 75,
  "volkswagen finance": 75,
  "volkswagen financial services no.2 ltd": 75,
  "volkswagen financial svcs ltd - cons (i)": 75,
  "volkswagen financial svcs ltd-cons": 75,
  "volkwagen financial services": 75,
  "fce bank plc": 75,
  "fce bank plc t/a ford credit": 75,
  "ford credit": 75,
  "ford credit europe plc": 75,
  "alphera financial services": 150,
  "alphera financial services (i)": 150,
  "autobank financial services": 150,
  "bmw finance": 150,
  "bmw financial services": 150,
  "bmw financial services (gb) limited": 150,
  "bmw financial services (gb) ltd": 150,
  "bmw financial svcs t/a alphera": 150,
  "citreon finance": 150,
  "clydesdale finance/barclays partner finance": 150,
  "clydesdale financial services ltd": 150,
  gmac: 150,
  "gmac uk plc": 150,
  "mercedes benz fnancial svs uk ltd": 150,
  "mercedes benz fnancial svs uk ltd (i)": 150,
  "mercedes-benz financial services": 150,
  "mercedes-benz financial services uk limited": 150,
  "mercedes-benz financial services uk ltd": 150,
  "mini financial services": 150,
  "peugeot financial services": 150,
  "psa finance": 150,
  "psa finance uk": 150,
  "stellantis financial services": 150,
  "stellantis financial services (i)": 150,
  "stellantis financial services uk": 150,
  "stellantis financial services uk limited": 150,
  "stellantis financial services uk ltd": 150,
  "stellantis financial services uk ltd (i)": 150,
  "ca auto finance uk ltd": 200,
  "close brothers limited": 200,
  "close brothers ltd": 200,
  "close brothers motor finance": 200,
  "close motor finance limited": 200,
  "close motor finance limited (i)": 200,
  "fca automotive services uk limited (i)": 200,
  "fca automotive services uk ltd": 200,
  "fca automotive services/ca auto finance": 200,
  "fga capital uk limited consumer": 200,
  "hitachi capital": 200,
  "hitachi capital consumer finance": 200,
  "mitsubishi capital": 200,
  "mitsubishi hc capital uk plc novuna (i)": 200,
  novuna: 200,
  "novuna business finance": 200,
  "novuna consumer finance": 200,
  "novuna vehicle solutions": 200,
  "novuna vehicle solutions limited": 200,
  "bank of scotland": 250,
  "bank of scotland motor": 250,
  "bank of scotland plc": 250,
  "bank of scotland plc (i)": 250,
  "black horse": 250,
  "black horse dealer finance-cons": 250,
  "black horse limited": 250,
  "black horse limited (no. 2)": 250,
  "black horse ltd": 250,
  "black horse ltd (i)": 250,
  halifax: 0,
  "halifax (i)": 0,
  "halifax motor": 0,
  "halifax motors": 0,
  "international motor finance limited": 250,
  "international motors finance limited": 250,
  jaguar: 250,
  "jaguar financial services": 250,
  "jaguar uwrite by black horse": 250,
  "jeep financial services": 250,
  "land rover": 250,
  "land rover financial services": 250,
  "land rover uwrite by black horse": 250,
  "lloyds bank": 250,
  "lloyds bank motor": 250,
  "lloyds bank plc": 250,
  "lloyds bank plc (i)": 250,
  "motonovo finance": 250,
  "motonovo finance(2) (i)": 250,
  "motonovo finance2": 250,
  "proton finance ltd": 250,
  "santander consumer": 250,
  "santander consumer (i)": 250,
  "santander consumer (uk) plc": 250,
  "santander consumer finance": 250,
  "santander consumer finance (uk) plc": 250,
  "santander consumer uk plc": 250,
  "shogun finance": 250,
  "shogun finance ltd": 250,
  "suzuki financial services": 250,
  "247 money": 0,
  "247money": 0,
  "arkle finance ltd": 0,
  "arkle finance ltd t/a evington": 0,
  "burnley savings and loans ltd": 0,
  "burnley savings and loans ltd (i)": 0,
  "car finance 247": 0,
  "car finance 247 (i)": 0,
  "car finance247 limited": 0,
  "clydesdale finance": 0,
  "clydesdale finance (i)": 0,
  "conister bank limited": 0,
  "conister bank limited (i)": 0,
  "conister bank ltd": 0,
  "conister bank ltd (i)": 0,
  "credo asset finance ltd": 0,
  "credo capital finance": 0,
  "credo capital finance ltd": 0,
  "credo capital finance ltd (i)": 0,
  "hartwell finance": 0,
  "hartwell finance (i)": 0,
  "hartwell finance limited": 0,
  "hartwell finance ltd": 0,
  "hippo motor finance": 0,
  "hyundai car finance ltd": 0,
  "ignition credit plc": 0,
  "lexus financial services": 0,
  "mallard vehicle finance": 0,
  "mallard vehicle finance (i)": 0,
  "mazda financial services": 0,
  "metro bank plc (i)": 0,
  "mg motor financial services": 0,
  ratesetter: 0,
  "ratesetter (i)": 0,
  "ratesetter (metro bank plc)": 0,
  "ratesetter com": 0,
  "retail money market ltd (ratesetter.com)": 0,
  "toyota financial services": 0,
  "toyota financial services (uk) plc": 0,
  "toyota financial services (uk) plc (i)": 0,
  "toyota financial services uk plc": 0,
  "united trust": 0,
  "united trust bank": 0,
  "united trust bank limited": 0,
  "united trust bank ltd": 0,
  "v12 vehicle finance pcp": 0,
  "vauxhall finance": 0,
  "vauxhall finance uk": 0,
  volvo: 0,
  "volvo car financial services uk ltd": 0,
  "volvo car financial services uk ltd (i)": 0,
  "volvo cars uk": 0,
  "volvo finance": 0,
  "volvo financial services": 0,
};

export const LOW_VALUE_KEYWORDS = [
  "ford",
  "fce",
  "toyota",
  "stellantis",
  "volkswagen",
  "rci financial",
  "hyundai",
  "halifax",
];

// constants backed up from hubspot
export const LENDERS_DCA_NOT_REQUIRED_MAPPING = [
  "THE 1ST STOP GROUP LIMITED (I)",
  "ADVANTAGE FINANCE LTD (I)",
  "AUTOMONEY MOTOR FINANCE (I)",
  "FIRST RESPONSE FINANCE LTD (I)",
  "MONEYBARN NO 1 LTD T/A MONEYBARN (I)",
  "OODLE FIN SRVCS LTD TA OODLE CAR FIN (I)",
  "RATESETTER (I)",
  "FAMILY FINANCE (I)",
  "SPECIALIST MOTOR FINANCE LTD (I)",
  "Family Finance Ltd",
];

export const BLACKLISTED_LENDERS_MAPPING = [
  "THE 1ST STOP GROUP LIMITED (I)",
  "PERCH (I)",
  "TESCO BANK LOANS (I)",
  "VIRGIN MONEY PERSONAL LOANS (I)",
  "SAINSBURYS BANK LOANS 2 (I)",
  "SAINSBURYS BANK LOANS (I)",
  "EOS SOLUTIONS UK PLC (I)",
  "HSBC PLC (I)",
  "ARROW GLOBAL LTD (I)",
  "EOS SOLUTIONS-GO CAR CREDIT 010324 (I)",
  "NATIONWIDE BUILDING SOCIETY (I)",
  "MARKS & SPENCER FIN SERV PLC (C) (I)",
  "GLM FINANCE LTD (I)",
  "LENDABLE (I)",
  "BAMBOO LOANS (I)",
  "INVESTEC ASSET FINANCE PLC (I)",
  "LENDING WORKS (I)",
  "FIRST DIRECT (I)",
  "CLS FINANCE",
  "STONEACRE FINANCIAL SERVICES (I)",
  "CLS FINANCE (I)",
  "OAKBROOK FINANCE LIMITED (I)",
  "AMIGO LOANS LTD (I)",
  "SNAP-ON TOOLS LTD (I)",
  "DEBT MANAGERS LIMITED (I)",
  "THE ASSET EXCHANGE LTD (I)",
  "LOANS 2 GO LIMITED (I)",
  "AUTO ADVANCE (I)",
  "118118 MONEY (I)",
  "HAWBROOK BANK (I)",
  "PERCH CAPITAL",
  "LLOYDS BANK PERSONAL LOANS (I)",
  "SANTANDER UNSECURED LOAN (I)",
  "HSBC PLC (I)",
  "HALIFAX PERSONAL LOAN (I)",
  "TSB BANK PLC PERSONAL LOANS (I)",
  "NATWEST PERSONAL LOANS (I)",
  "PCF BANK (I)",
  "NATIONWIDE BUILDING SOCIETY (I)",
  "ARROW GLOBAL LTD (I)",
  "BANK OF SCOTLAND PERSONAL LOAN(I)",
  "PERCH (I)",
  "SAINSBURYS BANK LOANS 2 (I)",
  "SHAWBROOK BANK (I)",
  "THE ASSET EXCHANGE LTD (I)",
  "EVERYDAY LOANS (I)",
  "LOANS 2 GO LIMITED (I)",
  "TESCO BANK LOANS (I)",
  "ASSET LINK CAPITAL (NO.10) LIMITED (I)",
  "LENDABLE (I)",
  "MBNA LOANS (I)",
  "MUTUAL",
  "PLATA FINANCE (I)",
  "RBOS PERSONAL LOANS(I)",
  "AMIGO LOANS LTD (I)",
  "ARROW GLOBAL LIMITED",
  "BAMBOO (I)",
  "CHERRY GODFREY FINANCE LTD (I)",
  "CLOSE FINANCE (CI) LIMITED",
  "DEBT MANAGERS LIMITED (I)",
  "EOS SOLUTIONS-GO CAR CREDIT 010324 (I)",
  "GLM FINANCE LTD (I)",
  "LANTERN DEBT RECOVERY SERVICES UK LTD",
  "LINK FINANCIAL OUTSOURCING LIMITED",
  "LIVE LEND (I)",
  "MARKS & SPENCER FIN SERV PLC (C) (I)",
  "PERCH CAPITAL",
  "SAINSBURYS BANK LOANS (I)",
  "SNAP-ON TOOLS LTD (I)",
  "STONEACRE FINANCIAL SERVICES (I)",
  "VANQUIS LOANS(I)",
  "118118 MONEY (I)",
  "ABCUL SOUTHWARK CREDIT UNION (I)",
  "ABOUND (I)",
  "ALPHABET GB LIMITED (I)",
  "AUTO ADVANCE (I)",
  "AVELO LIMITED RE. CREDIT4CARS (I)",
  "BAMBOO LOANS (I)",
  "BETTERBORROW(I)",
  "CENTRAL TRUST PLC(I)",
  "CLOSE FNCE (CI) LTD (I)",
  "CLS FINANCE (I)",
  "COVENTRY BS GROUP (I)",
  "DEBT MANAGERS LIMITED",
  "DPM/ANGLO (I)",
  "EOS SOLUTIONS UK PLC - GCC (I)",
  "EOS SOLUTIONS UK PLC (I)",
  "EVOLUTION BANKING LTD (I)",
  "EVOLUTION FUNDING LIMITED (I)",
  "FIRST DIRECT (I)",
  "HASTINGS LOANS (I)",
  "IKANO (I)",
  "INVESTEC ASSET FINANCE PLC (I)",
  "LANTERN DEBT RECOVERY SERVICES LTD (I)",
  "LENDING WORKS (I)",
  "MUTUAL CLOTHING AND SUPPLY (I)",
  "NATIONWIDE BUILDING SOCIETY-MORTGAGES(I)",
  "NETWORK VEHICLES LTD",
  "NEWDAY (LOANS) (I)",
  "NEYBER LIMITED (I)",
  "NORTON HOME LOANS (I)",
  "OAKBROOK FINANCE LIMITED (I)",
  "SHAWBROOK BANK AG (I)",
  "STREET UK (I)",
  "UKMLL T/A PEPPER MONEY (I)",
  "VIRGIN MONEY PERSONAL LOANS (I)",
  "Grand Total",
];

export const LENDERS_IDV_REQUIRED_MAPPING = [
  "ALPHERA FINANCIAL SERVICES (I)",
  "-BARCLAYS BANK(AUDIT)",
  "BLACK HORSE LTD (I)",
  "BLUE MOTOR FINANCE LTD (I)",
  "BMW FINANCIAL SERVICES (GB) LTD",
  "CLYDESDALE FINANCE (I)",
  "CLOSE MOTOR FINANCE LIMITED (I)",
  "CONISTER BANK LTD (I)",
  "FCA AUTOMOTIVE SERVICES UK LIMITED (I)",
  "FCE BANK PLC",
  "LAND ROVER UWRITE BY BLACK HORSE",
  "MERCEDES BENZ FNANCIAL SVS UK LTD (I)",
  "NIIB GROUP/NORTHRIDGE FINANCE (I)",
  "PARAGON MOTOR FINANCE (I)",
  "RCI FINANCIAL SERVICES LTD (PERSONAL)(I)",
  "TOYOTA FINANCIAL SERVICES (UK) PLC (I)",
  "VOLKSWAGEN FINANCIAL SVCS LTD - CONS (I)",
  "SHOGUN FINANCE LTD",
  "MI VEHICLE FINANCE LTD (I)",
  "Alphera Financial Services (BMW)",
  "Barclays Partner Finance",
  "Black Horse Finance",
  "Blue Motor Finance Ltd",
  "BMW Financial Services",
  "Clydesdale Financial Services Ltd",
  "Close Brothers Motor Finance",
  "FCA Automotive Services Ltd (Fiat/Chrysler)",
  "FCE Bank plc (Ford Credit)",
  "Land Rover Financial Services (Black Horse)",
  "Mercedes-Benz Financial Services UK Limited",
  "Northridge Finance",
  "RCI Financial Services",
  "Toyota Financial Services(UK)plc",
  "Volkswagen Financial Services",
  "Hitachi Capital(UK)plc",
  "Creation Financial Services",
  "ALD Automotive UK",
  "Novuna Personal Finance",
  "FCA Automotive Services Ltd (Fiat/Chrysler)",
  "Hippo Motor Finance",
];

export const LENDERS_DCA_REQUIRED_MAPPING = [
  "ALPHERA FINANCIAL SERVICES (I)",
  "-BARCLAYS BANK(AUDIT)",
  "BLACK HORSE LTD (I)",
  "BLUE MOTOR FINANCE LTD (I)",
  "BMW FINANCIAL SERVICES (GB) LTD",
  "BMW FINANCIAL SERVICES (GB) LTD (I)",
  "CLYDESDALE FINANCE (I)",
  "CLOSE MOTOR FINANCE LIMITED (I)",
  "CONISTER BANK LTD (I)",
  "FCA AUTOMOTIVE SERVICES UK LIMITED (I)",
  "FCE BANK PLC",
  "FCE BANK PLC (I)",
  "HYUNDAI CAPITAL UK LTD (I)",
  "LAND ROVER UWRITE BY BLACK HORSE",
  "LAND ROVER UWRITE BY BLACK HORSE (I)",
  "MERCEDES BENZ FNANCIAL SVS UK LTD (I)",
  "SECURE TRUST BANK MOTOR FINANCE (I)",
  "MOTONOVO FINANCE(2) (I)",
  "NIIB GROUP/NORTHRIDGE FINANCE (I)",
  "PARAGON MOTOR FINANCE (I)",
  "PCF BANK (I)",
  "RCI FINANCIAL SERVICES LTD (PERSONAL)(I)",
  "SANTANDER CONSUMER (I)",
  "STARTLINE MOTOR FINANCE LTD (I)",
  "STELLANTIS FINANCIAL SERVICES UK LTD (I)",
  "STELLANTIS FINANCIAL SERVICES (I)",
  "TOYOTA FINANCIAL SERVICES (UK) PLC (I)",
  "VOLKSWAGEN FINANCIAL SVCS LTD - CONS (I)",
  "MARSH FINANCE & COMMERCIAL (I)",
  "Alphera Financial Services (BMW)",
  "Barclays Partner Finance",
  "Black Horse Finance",
  "Blue Motor Finance Ltd",
  "BMW Financial Services",
  "Clydesdale Financial Services Ltd",
  "Close Brothers Motor Finance",
  "FCA Automotive Services Ltd (Fiat/Chrysler)",
  "FCE Bank plc (Ford Credit)",
  "Hyundai Capital UK Limited",
  "Land Rover Financial Services (Black Horse)",
  "Mercedes-Benz Financial Services UK Limited",
  "Secure Trust Bank ( Moneyway)",
  "MotoNovo Finance",
  "Northridge Finance",
  "PCF Bank",
  "RCI Financial Services",
  "Santander Consumer Finance (Car Finance)",
  "Startline Motor Finance Limited",
  "Stellantis Financial Services",
  "Stellantis Financial Services",
  "Toyota Financial Services(UK)plc",
  "Volkswagen Financial Services",
  "Vauxhall Finance PLC",
  "SEAT Financial Services (Volkswagen)",
  "Porsche Financial Services (Volkswagen)",
  "Peugeot Financial Services",
  "Nissan Financial Services",
  "Moneyway",
  "Hitachi Capital(UK)plc",
  "GMAC UK Plc",
  "Creation Financial Services",
  "Citroen Finance (PSA Finance UK)",
  "247Money",
  "ALD Automotive UK",
  "CREDO CAPITAL FINANCE LTD (I)",
  "STONEACRE FINANCIAL SERVICES (I)",
  "ASSET LINK CAPITAL (NO.10) LIMITED (I)",
  "HSBC PLC (I)",
  "SHOGUN FINANCE LTD",
  "MI VEHICLE FINANCE LTD (I)",
  "EOS SOLUTIONS-GO CAR CREDIT 010324 (I)",
  "HONDA FINANCE EUROPE PLC (I)",
  "THE ASSET EXCHANGE LTD (I)",
  "Novuna Personal Finance",
  "Mitsubishi HC Capital UK PLC",
  "Lexus Financial Services",
  "FCA Automotive Services Ltd (Fiat/Chrysler)",
  "Hippo Motor Finance",
  "Renault Financial Services",
  "PSA Finance UK Limited",
  "Kia Finance",
  "Audi Finance (Volkswagen)",
  "Hartwell Finance Ltd",
  "MITSUBISHI HC CAPITAL UK PLC NOVUNA",
  "MITSUBISHI HC CAPITAL UK PLC NOVUNA (I)",
  "ZOPA LTD",
  "ZOPA LTD (I)",
  "ADMIRAL FINANCIAL SERVICES LIMITED",
  "ADMIRAL FINANCIAL SERVICES LIMITED (I)",
  "THE FIRST STOP GROUP LIMITED",
  "THE FIRST STOP GROUP LIMITED (I)",
  "ALPHERA FINANCIAL SERVICE",
  "ALPHERA FINANCIAL SERVICE (I)",
  "MOTONOVA FINANCE",
  "MOTONOVA FINANCE (I)",
  "FCA AUTOMATIVE SERVICES UK LIMITED",
  "FCA AUTOMATIVE SERVICES UK LIMITED (I)",
  "LLOYDS BANK PLC (I)",
  "ARROW GLOBAL LTD (I)",
  "Novuna Personal Finance",
  "Mitsubishi HC Capital UK PLC",
  "Lexus Financial Services",
  "FCA Automotive Services Ltd (Fiat/Chrysler)",
  "Hippo Motor Finance",
  "Renault Financial Services",
  "PSA Finance UK Limited",
  "Kia Finance",
  "Audi Finance (Volkswagen)",
  "Hartwell Finance Ltd",
  "Dacia Financial Services",
];
